import React from 'react';
import RoleBasedRoute from './RoleBasedRoute';

/**
 * Protected route specifically for reporter users
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authenticated
 * @returns {React.ReactNode} - The protected component or redirect
 */
const ReporterRoute = ({ children }) => {
  return (
    <RoleBasedRoute 
      allowedRoles="Reporter" 
      redirectPath="/login"
    >
      {children}
    </RoleBasedRoute>
  );
};

export default ReporterRoute;
